import { render, staticRenderFns } from "./adminIndex.vue?vue&type=template&id=42f01cdc&"
import script from "./adminIndex.vue?vue&type=script&lang=js&"
export * from "./adminIndex.vue?vue&type=script&lang=js&"
import style0 from "./adminIndex.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports